// @flow
import * as React from "react";
import Form from "react-bootstrap/Form";
import Avatar from "../../Assets/images/avatar.png";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { ProgressBar } from "primereact/progressbar";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import Swal from "sweetalert2";
import { yupResolver } from "@hookform/resolvers/yup";
import SelectButtonFormat from "../../Landing/Components/FormOptions/SelectButtonFormat";
export const Video = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [avatarSrc, setAvatarSrc] = useState("");
  const [Logo, setLogo] = useState("");
  const [video, setVideo] = useState("");
  const [videoSrc, setVideoSrc] = useState(null);

  const [thumbnail, setThumbnail] = useState("");
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [defaultRows, setDefaultRows] = useState(20);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const defaultValues = {
    title: "",
    description: "",
    sort: "",
    status: 1,
    thumbnail: "",
    vid: "",
    url: "",
    catid: "",
    duration: "",
    position: "",
    img: "",
  };
  const [selecteVideoId, setSelectedVideoId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const schema = yup.object({
    duration: yup.string().required("زمان ویدئو وارد نشده است."),
    url: yup.string().required("فایل ویدئو انتخاب نشده است."),
  });
  const {
    handleSubmit,
    reset,
    control,
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const cols = [
    {
      field: "title",
      header: "عنوان",
    },
    { field: "description", header: "توضیحات" },
    {
      field: "duration",
      header: " زمان(ثانیه)",
    },
    { field: "status", header: "وضعیت نمایش" },
    {
      field: "sort",
      header: "اولویت",
    },
    {
      field: "thumbnail",
      header: "کاور",
    },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
    {
      field: "CityName",
      header: "حذف",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"remove"}
            onClick={() => handleDelete(data?.FId)}
            className="icon-sm btn-danger bg-danger   p-1 text-white text-center rounded "
          />
        </div>
      ),
    },
  ];

  const onSubmit = async (data) => {
    SaveVideo(data);
  };

  const SaveVideo = async (data) => {
    let status;
    if (data?.status) {
      status = 1;
    } else {
      status = 0;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("catid", data?.catid);
    bodyFormData.append("title", data?.title);
    bodyFormData.append("description", data?.description);
    bodyFormData.append("sort", data?.sort);
    bodyFormData.append("status", status);
    bodyFormData.append("url", video);
    bodyFormData.append(
      "thumbnail",
      typeof avatarSrc === "string" ? "" : avatarSrc
    );
    bodyFormData.append("duration", data?.duration);
    bodyFormData.append("position", data?.position);

    let cmd = "createvideo";
    if (selecteVideoId) {
      bodyFormData.append("vid", selecteVideoId);
      cmd = "updatevideo";
    }

    try {
      setShowProgressBar(true);
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        onUploadProgress: (progressEvent) => {
          const calculatedProgress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(calculatedProgress);
        },
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        setProgress(0);
        SweetAlert({
          title: "",
          text: "ویدئو  با موفقیت ذخیره شد.",
          type: "success",
        });
        getVideos();
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel video  Error: ", error);
    } finally {
      setShowProgressBar(false);
    }
  };

  useEffect(() => {
    getVideos();
  }, []);
  const getVideos = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("catid", 1);
    fetchData("getvideo", bodyFormData, handleApiResponse);
  };
  const handleApiResponse = (data) => {
    setPageData(data?.dt);
    reset({ ...defaultValues, ...data?.dt });
  };
  const handleOpeEditItem = (data) => {
    setShowEditComponent(true);
    if (data) {
      setSelectedVideoId(data?.vid);
      setAvatarSrc(data?.thumbnail);
      setVideoSrc(data?.url);
      setTimeout(() => {
        setIsEditMode(true);
      }, 10);
      reset({ ...defaultValues, ...data });
    } else {
      reset(defaultValues);
      setIsEditMode(false);
      setAvatarSrc("");
      setVideoSrc(null);
    }
  };

  const toast = useRef(null);
  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "لغو شد",
      detail: "درخواست حذف لغو شد",
      life: 3000,
    });
  };
  const handleOpeDeleteItem = async (id) => {
    const bodyFormData = new FormData();
    bodyFormData.append("fid", id);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "delfeatures",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        toast.current.show({
          severity: "info",
          summary: "تایید شد",
          detail: "درخواست شما انجام شد",
          life: 3000,
        });
        fetchData("getvideo", {}, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel video  Error: ", error.message);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      show: true,
      title: "حذف ویدئو",
      text: "آیا می خواهید آیتم را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleOpeDeleteItem(id);
      }
    });
  };
  const handleUpload = async (w, h, sednFile) => {
    if (!sednFile) {
      return;
    }
    const image = new Image();
    image.src = sednFile;
    const cWith = w;
    const cHeight = h;
    let percentWidth = 0;
    let percentHeight = 0;
    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const orginalWidht = image.naturalWidth;
      const orginalHeight = image.naturalHeight;
      if (cWith === 0 || cHeight === 0) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      } else {
        percentWidth = cWith / orginalWidht;
        percentHeight = cHeight / orginalHeight;
        const percent =
          percentHeight < percentWidth ? percentHeight : percentWidth;
        canvas.width = image.naturalWidth * percent;
        canvas.height = image.naturalHeight * percent;
      }
      canvas
        .getContext("2d")
        .drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(async (blob) => {
        const myImage = new File([blob], "my-new-name.webp", {
          type: blob.type,
        });
        const formData = new FormData();
        formData.append("file", myImage);
        formData.append("guid", Cookies.get("guid"));
        setAvatarSrc(myImage);
      }, "image/webp");
    };
  };

  const handleSendImage = (image) => {
    const width = 800;
    const height = 800;
    handleUpload(width, height, image);
  };

  const handleSendVidoe = (value) => {};
  const stOptions = [
    { label: "فعال", value: 1 },
    { label: "غیرفعال", value: 0 },
  ];
  return (
    <PanelContainer title={"افزودن/ ویرایش ویدئو"}>
      <div className="row text-right  p-sm-0  data-table">
        <Toast ref={toast} />
        <DataTableTemplate
          lazyState={lazyState}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
          paginator={false}
        />
        <div className="col-6 mt-5">
          <Button className="" onClick={() => handleOpeEditItem()}>
            افزودن
          </Button>
        </div>
      </div>
      {showEditComponent && (
        <>
          <div className="panel-heading prime-bg text-white text-center py-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش ویدئو" : "افزودن ویدئو جدید"}
            </span>
          </div>
          <div className="panel-body">
            <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="sort"
                    type={"tel"}
                    defaultValue={""}
                    label="اولویت"
                    errors={errors}
                  />
                </div>
                <div className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="duration"
                    type={"tel"}
                    defaultValue={""}
                    label="زمان ویدئو"
                    errors={errors}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="catid"
                    type={"tel"}
                    defaultValue={""}
                    label="دسته بندی"
                    errors={errors}
                  />
                </div>
                <div className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="title"
                    type={"text"}
                    label="عنوان "
                    errors={errors}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="description"
                    type={"text"}
                    label="توضیحات"
                    errors={errors}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="position"
                    type={"text"}
                    label="پوزیشن"
                    errors={errors}
                  />
                </div>
                <div className="col-12 col-lg-6">
                  {/* <CheckboxFormat
                    control={control}
                    name="status"
                    errors={errors}
                    type="checkbox"
                    label="وضعیت نمایش"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start gap-2">
                    <Form.Label className="fw-bold pb-1">وضعیت نمایش</Form.Label>
                    <SelectButtonFormat
                      name={"status"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-center m-auto ">
                  <img
                    id="avatar"
                    className="avatar"
                    onClick={() => document.getElementById("fileInput").click()}
                    alt="برای ارسال عکس کلیک کنید"
                    src={!Logo ? `https://api.taab30.com${avatarSrc}` : Logo}
                  />
                  <input
                    type="file"
                    id="fileInput"
                    className="d-none"
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        setLogo(URL.createObjectURL(e.target.files[0]));
                        handleSendImage(URL.createObjectURL(e.target.files[0]));
                      }
                      setTimeout(() => {}, 1);
                      //
                    }}
                  />
                  {!video ||
                    (!videoSrc && (
                      <span className="text-danger">
                        {"فایل ویدئو را آپلود کنید"}
                      </span>
                    ))}
                  <button
                    id="btn-upload"
                    className="d-none"
                    onClick={() => handleSendImage()}
                  >
                    click
                  </button>
                  <div id="progressbar" className="d-none text-center">
                    <p className="text-center">در حال بارگزاری فایل</p>
                    <progress content="10" id="fileProgress"></progress>
                  </div>
                  <br />
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="col-12  m-auto ">
                  {/* <ReactPlayer
                                        width={"30%"}
                                        height={"30%"}
                                        // class={'m-auto'}
                                        url={`https://api.taab30.com${videoSrc || ''}`}
                                        controls
                                        playsinline

                                    /> */}
                  {/*<video src={ !video ? `https://api.taab30.com${videoSrc}`: video}     onClick={() => document.getElementById('fileInput').click()} >ارسال ویدئو</video>*/}
                  <input
                    type="file"
                    id="videoInput"
                    className="d-none"
                    accept="video/*"
                    onChange={(e) => {
                      console.log(e.target.files);
                      if (e.target.files.length > 0) {
                        setVideo(e.target.files[0]);
                        handleSendVidoe(e.target.files[0]);
                      }
                      // setLogo((prevState) => (e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : prevState));
                      setTimeout(() => {
                        // document.getElementById('btn-upload').click()
                      }, 1);
                      //
                    }}
                  />
                  {showProgressBar && (
                    <div>
                      <p>{`${progress}% Uploaded`}</p>
                      <ProgressBar value={progress} />
                    </div>
                  )}
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() =>
                      document.getElementById("videoInput").click()
                    }
                  >
                    انتخاب ویدئو
                  </button>
                  <div id="progressbar" className="d-none text-center">
                    <p className="text-center">در حال بارگزاری فایل</p>
                    <progress content="10" id="fileProgress"></progress>
                  </div>
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-12" dir="ltr">
                  <Button type="submit">ذخیره</Button>
                </div>
              </div>
            </Form>
          </div>
        </>
      )}
    </PanelContainer>
  );
};
